import React, { FC } from 'react';
import PlaceholderImage from 'style/imgs/icons/info-popup-icon.png';
import styles from './index.module.scss';

interface InfoPopupProps {
  title: string;
  imageUrl?: string;
  style?: React.CSSProperties;
}

const InfoPopup: FC<InfoPopupProps> = ({ title, imageUrl, style }) => {
  return (
    <div className={styles.infoPopup} style={style && style}>
      <span className={styles.infoPopupText}>{title}</span>
      <img
        className={styles.infoPopupImage}
        src={imageUrl || PlaceholderImage}
        alt={title}
      />
    </div>
  );
};

export default InfoPopup;
